/**
 * The MetaPhase symbol.
 *
 * Vectorised from the supplied mark with potrace, tracing the alpha channel
 * rather than a luminance threshold: the mark is one solid colour on nothing,
 * so the alpha is the silhouette exactly and no thresholding decision has to be
 * guessed at. The result was compared against the original before use.
 *
 * Inline rather than an image file, and `fill="currentColor"` rather than the
 * brand orange baked in, so the surface it sits on decides the colour. The
 * footer wants it in the accent; a light background would want it in the ink.
 * An `<img>` could do neither without shipping a second file.
 *
 * Decorative wherever it is used: it is always beside the operator's name in
 * text, so it carries `aria-hidden` and adds nothing to the accessibility tree.
 *
 * The transform is potrace's own. It traces in a y-up coordinate space at ten
 * times the scale, so the group flips and divides it back. Leave it alone; the
 * path data is expressed in those units.
 */
export default function MetaPhaseSymbol({
  className = 'size-9',
}: {
  className?: string
}) {
  return (
    <svg
      viewBox="0 0 174 174"
      className={className}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <g transform="translate(0,174) scale(0.1,-0.1)">
        <path
          d="M463 1620 c-142 -29 -289 -164 -333 -308 -38 -122 -22 -253 48 -386
28 -54 63 -96 146 -178 105 -102 110 -108 111 -151 3 -54 32 -105 73 -130 41
-23 118 -22 160 3 129 79 73 283 -79 286 -48 0 -51 2 -148 96 -130 126 -156
176 -156 303 0 74 4 98 23 132 35 67 78 110 144 143 51 25 73 30 134 30 40 0
84 -4 97 -9 21 -8 31 -3 81 48 l57 58 -58 26 c-96 42 -203 56 -300 37z"
        />
        <path
          d="M1061 1615 c-107 -30 -170 -72 -293 -197 -112 -112 -120 -118 -158
-118 -88 0 -144 -59 -145 -151 0 -94 58 -154 150 -154 88 0 145 56 153 151 5
57 5 57 106 159 128 129 168 150 286 150 73 0 92 -4 135 -27 132 -70 200 -216
166 -354 l-12 -47 53 -54 c29 -29 55 -53 59 -53 8 0 44 89 58 145 18 67 13
189 -10 257 -38 114 -131 217 -245 270 -56 26 -81 31 -158 34 -61 3 -109 -1
-145 -11z"
        />
        <path
          d="M1070 1272 c-53 -29 -80 -75 -80 -137 0 -91 65 -155 156 -155 39 0
48 -6 141 -97 119 -117 156 -180 161 -283 11 -204 -181 -367 -378 -320 l-52
12 -54 -53 c-36 -35 -50 -56 -44 -64 5 -6 40 -22 77 -35 57 -21 86 -25 179
-25 107 0 112 1 186 38 170 83 269 254 255 438 -12 151 -81 275 -230 414 -91
85 -95 90 -95 131 0 23 -7 55 -16 72 -36 71 -137 102 -206 64z"
        />
        <path
          d="M142 772 c-30 -70 -43 -136 -43 -219 0 -131 40 -225 136 -318 105
-102 229 -144 365 -125 158 22 239 72 408 253 55 58 69 67 98 67 50 0 98 23
128 62 79 105 8 248 -125 248 -85 0 -149 -68 -149 -158 0 -39 -6 -49 -77 -125
-42 -45 -90 -92 -107 -105 -175 -133 -391 -88 -488 102 -25 49 -36 169 -19
217 11 31 9 34 -41 88 -29 31 -56 57 -59 59 -3 1 -16 -19 -27 -46z"
        />
      </g>
    </svg>
  )
}
